import allowance from '@/api/mission/allowance-condition'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return allowance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return allowance.store(data)
  },
  update(context, { id, data }) {
    return allowance.update(id, data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await allowance.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  switchActive(context, id) {
    return allowance.switchActive(id)
  },


  
}
